import { call, select } from 'redux-saga/effects';
import isEqual from 'lodash.isequal';
import { SignalingSocket } from 'services/signaling';
import {
  selectPinnedPanels,
  selectRemotePinnedPanels,
  selectPinnedPanelsAvailable,
} from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';

export function* changePinnedPanelsSaga() {
  const pinnedPanelsAvailable: boolean = yield select(selectPinnedPanelsAvailable);

  if (!pinnedPanelsAvailable) {
    return;
  }

  const panels: SidePanelType[] = yield select(selectPinnedPanels);
  const remotePanels: SidePanelType[] = yield select(selectRemotePinnedPanels);

  if (isEqual(panels, remotePanels)) {
    return;
  }

  yield call(SignalingSocket.send, {
    event: 'changePinnedPanels',
    data: { panels },
  });
}
